import { FiChevronRight, FiChevronLeft } from "react-icons/fi";
import React, { useState } from "react";
import { useRouter } from "next/router";
const MagazinePage = () => {
  const {locale} = useRouter()
  const [page, setPage] = useState(1);
  return (
    <div className="p-4 relative flex items-center justify-center">
      {/*  eslint-disable-next-line @next/next/no-img-element */}
      <img
        className="max-w-[700px] w-[100%] h-auto object-contain"
        src={`/imgs/magazine/${page}.png`}
        width={2000}
        height={3000}
        alt="Company Certificate Image"
      />
      <div className={`absolute top-1/2 -translate-y-1/2 left-0 w-full flex ${locale === 'ar' ? 'flex-row-reverse' : 'flex-row'} justify-between items-center`}>
        <button
          disabled={page === 44}
          onClick={() => {
            setPage(prev => prev + 1);
          }}
          className="text-7xl cursor-pointer disabled:text-slate-400 text-red"
          >
          <FiChevronLeft />
        </button>
        <button
          disabled={page === 1}
          onClick={() => {
            setPage(prev => prev - 1);
          }}
          className="text-7xl cursor-pointer disabled:text-slate-400 text-red"
        >
          <FiChevronRight />
        </button>
      </div>
    </div>
  );
};

export default MagazinePage;
